import moment from 'moment';

export const isPlainObject = (val) => {
  if (val == null || typeof val !== 'object') return false;

  const proto = Object.getPrototypeOf(val);

  // Если прототипа нет (объект создан через Object.create(null)),
  // то это "простой" объект. Возвращаем true.
  if (proto === null) return true;

  // Достаем конструктор из прототипа.
  // Используем hasOwnProperty напрямую из Object.prototype на случай,
  // если у самого proto это свойство переопределено или отсутствует.
  const constructor =
    Object.prototype.hasOwnProperty.call(proto, 'constructor') &&
    proto.constructor;

  // Проверка на "простоту" через строковое сравнение:
  // Нативные конструкторы всегда возвращают строку вида "function Object() { [native code] }".
  // Поскольку в разных iframe разные функции Object, сравнение Object.prototype не сработает,
  // а сравнение текста их исходного кода (который всегда одинаковый для нативных функций) — сработает.
  return (
    typeof constructor === 'function' &&
    Function.prototype.toString.call(constructor) ===
      Function.prototype.toString.call(Object)
  );
};

export const isFn = (value) => {
  return typeof value === 'function';
};

export const deepClone = (value, hash = new WeakMap()) => {
  if (value == null || typeof value !== 'object') {
    return value;
  }

  if (hash.has(value)) {
    return hash.get(value);
  }

  if (moment.isMoment(value)) {
    const output = value.clone();
    hash.set(value, output);
    return output;
  }

  if (value instanceof Date) {
    const output = new Date(value.getTime());
    hash.set(value, output);
    return output;
  }

  if (value instanceof Map) {
    const output = new Map();
    hash.set(value, output);
    value.forEach((v, k) => {
      output.set(k, deepClone(v, hash));
    });
    return output;
  }

  if (value instanceof Set) {
    const output = new Set(value);
    hash.set(value, output);
    return output;
  }

  if (Array.isArray(value)) {
    const output = [];
    hash.set(value, output);
    value.forEach((item, index) => {
      output[index] = deepClone(item, hash);
    });
    return output;
  }

  if (isPlainObject(value)) {
    const output = Object.create(Object.getPrototypeOf(value));
    hash.set(value, output);

    Object.entries(value).forEach(([k, v]) => {
      output[k] = deepClone(v, hash);
    });

    return output;
  }

  return value;
};
